var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPapuaNewGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1422 34.1421C26.3317 41.9526 13.6685 41.9526 5.85784 34.1421C-1.95263 26.3317 -1.95263 13.6683 5.85792 5.85775C13.6684 -1.95272 25.1019 -0.722957 32.9124 7.08759C40.7228 14.8981 41.9526 26.3317 34.1422 34.1421V34.1421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85791 5.8578C13.6684 -1.95267 26.3316 -1.95251 34.1422 5.85788C41.9527 13.6683 41.9527 26.3316 34.1422 34.1422",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2844 26.9566L15.6081 27.9531H16.6559L15.8082 28.5689L16.132 29.5654L15.2844 28.9495L14.4367 29.5654L14.7605 28.5689L13.9129 27.9531H14.9606L15.2844 26.9566Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6086 17.3913L13.1484 19.0521H14.8945L13.4817 20.0785L14.0213 21.7392L12.6086 20.7127L11.1959 21.7392L11.7356 20.0785L10.3228 19.0521H12.0691L12.6086 17.3913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6086 29.5653L13.1482 31.2261H14.8945L13.4816 32.2524L14.0213 33.9132L12.6086 32.8867L11.1959 33.9132L11.7355 32.2524L10.3228 31.2261H12.0688L12.6086 29.5653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7141 21.7392L18.2539 23.4H20L18.5872 24.4263L19.1268 26.0871L17.7141 25.0606L16.3015 26.0871L16.8411 24.4263L15.4284 23.4H17.1746L17.7141 21.7392Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50307 21.7392L8.04283 23.4H9.78885L8.37619 24.4263L8.91572 26.0871L7.50307 25.0606L6.09033 26.0871L6.6301 24.4263L5.21729 23.4H6.96346L7.50307 21.7392Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4803 14.8095C32.5865 13.9157 31.4251 13.3876 30.177 13.2969L33.913 10.3912C32.4251 8.90332 30.4308 8.23136 28.4849 8.37347C28.2519 7.53629 27.8078 6.74551 27.1494 6.08715L25.6737 9.03855C25.5769 8.86215 25.4544 8.69613 25.3048 8.54668C24.4558 7.69769 23.0794 7.69769 22.2304 8.54668C21.3815 9.39566 21.3814 10.7721 22.2304 11.6211C22.3799 11.7705 22.546 11.8931 22.7224 11.99L19.771 13.4657C20.4295 14.1243 21.2208 14.5687 22.0585 14.8015C21.9159 16.7475 22.5872 18.7414 24.0751 20.2293L27.3392 16.0326C27.5847 15.7908 27.909 15.6573 28.254 15.6573C28.6025 15.6573 28.93 15.7929 29.1763 16.0394C29.4227 16.2857 29.5584 16.6133 29.5584 16.9617C29.5584 17.3101 29.4227 17.6376 29.1763 17.884L30.4062 19.1139C30.9809 18.539 31.2976 17.7747 31.2976 16.9618C31.2976 16.2966 31.0854 15.6643 30.6937 15.1414C31.2644 15.2939 31.8039 15.5925 32.2508 16.0394C33.607 17.3956 33.607 19.6023 32.2508 20.9584L33.4806 22.1882C34.466 21.2028 35.0087 19.8926 35.0087 18.4989C35.0085 17.1051 34.4657 15.795 33.4803 14.8095V14.8095Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapuaNewGuinea);
export default __webpack_public_path__ + "static/media/papua_new_guinea.d8c9ff578abff5cf40dfa269c82872c0.svg";
export { ForwardRef as ReactComponent };